export enum ConstantsTabMain {
    TAB_AUSWAHL = 0,
    TAG_ERGEBNISSE = 1,
    TAG_EINSTELLUNGEN = 2
}
  
  